<section #heroSection class="hero container">
  <div class="mobile-pos">
    <div class="copy">
      <div class="name_sub_container">
        <h1>Ebubekir Elicora</h1>
        <p class="subtitle">{{ "about.subtitle" | translate }}</p>
        <p class="mobile-location">Herne</p>
      </div>
      <div class="portrait-wrap">
        <img
          class="portrait"
          src="assets/img/profile_img/Ebubekir_Elicora_PortfolioBild.webp"
          alt="Preview"
        />
      </div>
    </div>
  </div>
</section>

<img
  class="next-arrow"
  src="assets/img/icons/arrows/arrow_right.png"
  alt="Weiter"
  role="button"
  tabindex="0"
  (click)="onNext()"
  (keydown.enter)="onNext()"
  (keydown.space)="onNext()"
/>
